import { getTableColumns } from 'helpers';

const INDAgentColumns = [
  ['agentDeviceName', 'string', 'Agent', 'left', true],
  ['indIdeHolder', 'string', 'IND Holder', 'left', true],
  ['indIdeHolderName', 'string', 'IND Holder Name', 'left', true],
  ['indIdeNumber', 'string', 'IND #', 'left', true],
  ['esysStatus', 'string', 'Status', 'left', true],
  ['esysStatusDate', 'date', 'Status Date', 'left', true],
  ['modifiedUser', 'string', 'Last Modified By', 'left', true],
  ['modifiedDate', 'date', 'Last Modified Date', 'left', true]
];


export default getTableColumns(INDAgentColumns);
